import authRules from '../authRules.js';

const deleteAssignment = (user) => {
  const { scheduleData } = user.securityLevels;
  if (scheduleData >= authRules.deleteAssignment.scheduleData) {
    return true;
  } else {
    return false;
  }
}

export default deleteAssignment;
